import React, { useState } from 'react';

import { Button } from 'antd';
import qs from 'qs';
import { useMutation } from 'react-query';
import { EnrollmentFormServiceInstance } from 'services/enrollmentFormService';

import { ListContainer } from './UnfinishedEmail.style';

export interface UnfinishedEmailProps {
  email: string;
  ceoName: string;
  companyName: string;
  surveyId: string;
  enrollmentFormId: string;
}

const UnfinishedEmail = (props: UnfinishedEmailProps): JSX.Element => {
  const [success, setSuccess] = useState<boolean | undefined>();

  const resendEmailMutation = useMutation(
    EnrollmentFormServiceInstance.resendEnrollmentFormToEmail,
    {
      onSuccess: () => {
        setSuccess(true);
      },
      onError: () => {
        setSuccess(false);
      },
    }
  );

  function onClickResendEmail() {
    resendEmailMutation.mutate({ ...props });
  }

  function onClickCopyUniqueLinkToClipboard()
  {
    // 'http://survey-staging-304809.uc.r.appspot.com/answer-survey' +
    const text = process.env.REACT_APP_PUBLIC_URL + '/answer-survey' +
      qs.stringify(
        {
          surveyId: props.surveyId,
          enrollmentFormId: props.enrollmentFormId,
          email: btoa(props.email),
        },
        { addQueryPrefix: true }
      );

    // Copy contents
    if (!navigator.clipboard) {
      // Create a dummy input to copy the string array inside it
      const dummy = document.createElement('input');
      // Add it to the document
      document.body.appendChild(dummy);
      // Set its ID
      dummy.setAttribute('id', 'dummy_id');
      // Output the array into it
      (document.getElementById('dummy_id') as HTMLInputElement).value = text;
      // Select it
      dummy.select();

      document.execCommand('copy');

      // Remove it as its not needed anymore
      document.body.removeChild(dummy);
    } else {
      navigator.clipboard
        .writeText(text)
        .then(
          () => console.log('Async: Copying to clipboard was successful!'),
          err => console.error('Async: Could not copy text: ', err)
        );
    }
  }

  return (
    <li>
      <ListContainer>
        {props.email}

        <div style={{ marginLeft: 8 }}>
          {resendEmailMutation.isLoading && <p>Sending...</p>}

          {success === true && !resendEmailMutation.isLoading && (
            <Button style={{ backgroundColor: '#27ae60' }}>Success</Button>
          )}

          {success === false && !resendEmailMutation.isLoading && (
            <Button onClick={onClickResendEmail} danger>
              Failed
            </Button>
          )}

          {success === undefined && !resendEmailMutation.isLoading && (
            <Button onClick={onClickResendEmail} type="primary">
              Resend Email
            </Button>
          )}
        </div>

        <div style={{ marginLeft: 8 }}>
          <Button type="default" onClick={onClickCopyUniqueLinkToClipboard}>
            Copy Unique Link to Clipboard
          </Button>
        </div>
      </ListContainer>
    </li>
  );
};

export default UnfinishedEmail;
